import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ExceptionResolution } from '@usf/ngrx-order';
import { ImageVariantEnum } from 'src/app/product-detail/models/image-variant.enum';
import { getFirstImageURL } from 'src/app/product-detail/utils/product-images.util';
import { Product } from 'src/app/shared/models/product.model';
import { ResolutionType } from '../../../pages/order-exceptions/constants/resolution-type.enum';
import { EmittedResolution } from '../../../pages/order-exceptions/models/emitted-resolution.model';
import { ProductSummary } from '@usf/product-types';
import { getAlternativeThumbnail } from 'src/app/product-detail/utils/product-images.util';

@Component({
  template: '',
})
export class AcknowledgementRowBaseComponent implements OnChanges {
  @Input() exceptionResolution: ExceptionResolution;
  @Input() product: Product;
  @Input() productState: ProductSummary;
  @Input() isOffline: boolean;
  @Input() orderNumber: number;
  thumbnailImageURL: string;
  @Output() exceptionResolved = new EventEmitter();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.product?.currentValue) {
      this.thumbnailImageURL = getFirstImageURL(
        changes.product?.currentValue?.summary,
        ImageVariantEnum.Thumbnail,
      );
    }
  }

  getAternativeThumbnail = (thumbnailImageURL: string): string =>
    getAlternativeThumbnail(this.productState, thumbnailImageURL);

  confirm() {
    const resolution: EmittedResolution = {
      exceptionResolution: { ...this.exceptionResolution, expanded: false },
      resolutionType: ResolutionType.ACKNOWLEDGED,
    };
    this.exceptionResolved.emit(resolution);
  }

  edit() {
    const resolution: EmittedResolution = {
      exceptionResolution: { ...this.exceptionResolution, expanded: true },
      resolutionType: ResolutionType.ACKNOWLEDGED,
    };
    this.exceptionResolved.emit(resolution);
  }
}
